import auth from "../middleware/auth";

const Inicio = () => import("../components/Views/Biblioteca/Inicio.vue");
const ConsultaAcervo = () =>
  import("../components/Views/Biblioteca/ConsultaAcervo.vue");
const ConsultaAcervoPublica = () =>
  import("../components/Views/Biblioteca/ConsultaAcervoPublica.vue");
const ViewPublicacao = () =>
  import("../components/Views/Biblioteca/ViewPublicacao.vue");
const Home = () => import("../components/Views/Home.vue");
const HomeSimplePage = () => import("../components/Views/HomeSimplePage.vue");

const breadcrumb = [
  { name: "IntegradON", link: process.env.INTERNO_URL },
  { name: "Biblioteca", link: "/biblioteca" }
];

const breadcrumbPublico = [
  { name: "IntegradON", link: process.env.INTERNO_URL },
  { name: "Biblioteca", link: "/biblioteca/publico/consulta-acervo" }
];

const biblioteca = [
  {
    path: "/biblioteca",
    component: Home,
    children: [
      {
        path: "/biblioteca",
        component: Inicio,
        name: "Início",
        meta: {
          middleware: auth,
          breadcrumb
        }
      },
      {
        path: "/biblioteca/consulta-acervo",
        component: ConsultaAcervo,
        name: "Consulta ao Acervo",
        meta: {
          middleware: auth,
          breadcrumb
        }
      },
      {
        path:
          "/biblioteca/publicacao/:publicacao/:volume/:edicao/:ano/:paginas",
        component: ViewPublicacao,
        name: "Visualizar Publicação",
        meta: {
          middleware: auth,
          breadcrumb
        }
      }
    ]
  },
  {
    path: "/biblioteca",
    component: HomeSimplePage,
    children: [
      {
        path: "/biblioteca/publico/consulta-acervo",
        component: ConsultaAcervoPublica,
        name: "Consulta ao Acervo Pública",
        meta: {
          breadcrumb: breadcrumbPublico
        }
      },
      {
        path:
          "/biblioteca/publico/publicacao/:publicacao/:volume/:edicao/:ano/:paginas",
        component: ViewPublicacao,
        name: "Visualizar Publicação Publica",
        meta: {
          middleware: auth,
          breadcrumb: breadcrumbPublico
        }
      }
    ]
  }
];

export default biblioteca;



// WEBPACK FOOTER //
// ./src/routes/biblioteca.js